import styled from 'styled-components'

// TODO: Move some of this into individ modal?
const PublishTasksContainer = styled.div`
  .modal-wrapper {
    .ant-modal-content {
      background-color: #f4f3f3;
      .ant-modal-close {
        color: white !important;
        margin-top: -3.5px;
      }

      .ant-modal-header {
        background-color: #4c4c4c;

        .ant-modal-title {
          color: white !important;
        }
      }

      .ant-modal-body {
        padding: 0;

        .modal-inner {
          background: white;
          margin: 25px 33px;
          border-radius: 15px;

          .prompt-item {
            padding: 1rem;
          }
        }
      }

      .modal-custom-body {
        background-color: white;
        border-radius: 15px;

        h4 {
          text-align: center !important;
        }
      }

      .modal-footer {
        padding: 24px 0 0 0 !important;

        .actions {
          padding: 8px 0 !important;

          @media screen and (max-width: 450px) {
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin: 0 1rem;
          }

          .btn {
            margin-right: 1rem;
            font-size: 15px;
            padding: 0px 16px;
            height: 25px;
            border-radius: 5px;
          }

          .cancel {
            color: white;
          }
        }
      }
    }
  }

  .publish-btn {
    padding: 10px 3rem 30px 3rem;
    border-radius: 22px;
    margin-top: 24px;
  }

  .publish-task {
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    padding: 20px 20px 10px 20px;
    margin-bottom: 0;

    .completed-check {
      margin-left: auto;
    }

    .task-name {
      margin-bottom: 0;
    }
  }

  .publish-btns {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 1rem 0;

    button {
      font-size: 18px;
      height: 42px;
    }
  }
`
export default PublishTasksContainer
